import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { firstValueFrom } from 'rxjs';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { EFavoriteType, ProductIdentifierDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { IConfirmDialogService, IConfirmDialogServiceToken } from 'shared/services/ui/dialogs/confirm/confirm-dialog-service.abstract';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { IFavoriteService, IFavoriteServiceToken } from 'projects/shared/lib/services/data/favorite/favorite-service.interface';
import { ITooltipService, ITooltipServiceToken } from 'shared/services/ui/tooltip/tooltip-service.interface';


@Component({
  selector: 'app-product-favorite-icon',
  imports: [CommonModule],
  templateUrl: './product-favorite-icon.component.html',
  styleUrls: ['./product-favorite-icon.component.scss']
})
export class ProductFavoriteIconComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() productIdentifier?: ProductIdentifierDto;
  @Input() isFavorite: boolean | undefined;

  @Output() onFavoriteSet: EventEmitter<void>;
  @Output() onFavoriteRemove: EventEmitter<void>;

  @ViewChild('favoriteTooltipContainer') favoriteTooltipContainerRef: ElementRef<HTMLSpanElement> | undefined;
  public favoriteTooltipHtmlContent: string;
  private favoriteTooltip: Tooltip | undefined;

  public isEnabled: boolean;

  protected confirmDialogService: IConfirmDialogService;
  private logger: LoggerService;
  public readonly authService: IAuthService;
  private readonly favoriteService: IFavoriteService;
  private readonly toolTipService: ITooltipService = inject(ITooltipServiceToken);

  constructor(protected viewContainerRef: ViewContainerRef) {
    this.favoriteService = inject(IFavoriteServiceToken);
    this.authService = inject(IAuthServiceToken);
    this.logger = ServiceLocator.injector.get(LoggerService);
    this.onFavoriteSet = new EventEmitter();
    this.onFavoriteRemove = new EventEmitter();

    this.confirmDialogService = inject(IConfirmDialogServiceToken);
    this.isFavorite = false;
    this.favoriteTooltipHtmlContent = "";
    this.isEnabled = true;
  }

  public ngOnInit(): void {
    this.toolTipHtmlContentBind();
  }

  ngAfterViewInit(): void {
    if (this.favoriteTooltipContainerRef) {
      this.favoriteTooltip = new Tooltip(this.favoriteTooltipContainerRef?.nativeElement);
    }
  }

  public ngOnDestroy(): void {
    this.favoriteTooltip?.dispose();
  }

  public favoriteToggle() {
    if (!this.isEnabled) {
      return;
    }

    if (!this.isFavorite) {
      this.favoriteSet();
    } else {
      this.favoriteRemove();
    }
  }

  public favoriteRemove(favoriteType?: EFavoriteType | undefined) {
    if (!this.productIdentifier) {
      throw new Error('Missing productIdentifier upon removing the favorite property.');
    }

    if (this.isFavorite == false) {
      return;
    }

    this.isEnabled = false;

    firstValueFrom(this.favoriteService.favoriteDelete([this.productIdentifier], favoriteType)).then(
      (success: boolean) => {
        if (success) {
          this.isFavorite = false;
          this.onFavoriteRemove.emit();
        }
        this.isEnabled = true;
      },
      (er) => {
        this.logger.error(`${er}`, this.constructor.name);
        this.isEnabled = true;
      }
    );
  }

  public favoriteSet(favoriteType?: EFavoriteType | undefined) {
    if (!this.productIdentifier) {
      throw new Error('Missing productIdentifier upon removing the favorite property.');
    }

    if (this.isFavorite == true) {
      return;
    }

    this.isEnabled = false;

    firstValueFrom(this.favoriteService.favoriteSet([this.productIdentifier], favoriteType)).then(
      (success: boolean) => {
        if (success) {
          this.isFavorite = true;
          this.onFavoriteSet.emit();
        }
        this.isEnabled = true;
      },
      (er) => {
        this.logger.error(`${er}`, this.constructor.name);
        this.isEnabled = true;
      }
    );
  }

  private toolTipHtmlContentBind() {

    this.favoriteTooltipHtmlContent = this.toolTipService.favoriteToolTipGet();

  }
}
